import { faBullhorn } from '@fortawesome/pro-solid-svg-icons'
import { Alert } from '@/ui'
import {
  MESSAGES_LAUNCH_CARD_TEXT,
  MESSAGES_LAUNCH_CARD_TITLE,
} from '../lib/constants'

const DISMISSED_KEY = 'haven-messages-launch-card-dismissed'

export const MessagesLaunchCard = () => (
  <Alert
    customIconName={faBullhorn}
    title={MESSAGES_LAUNCH_CARD_TITLE}
    description={MESSAGES_LAUNCH_CARD_TEXT}
    dismissible
    permanentDismissalKey={DISMISSED_KEY}
  />
)
